import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserConnected } from '../../users/users.model';
import { UserService } from '../../users/users.service';

@Component({
  selector: 'app-dialog-connectedusrs',
  templateUrl: 'dialog-connected-users.component.html',
})
export class DialogConnectedUsersComponent implements OnInit {
  isLoadingResults = false;
  displayedColumns = ['userName', 'displayName', 'timestamp'];
  dataSource: MatTableDataSource<UserConnected>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public userService: UserService,
    public dialogRef: MatDialogRef<DialogConnectedUsersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.isLoadingResults = true;
    this.userService
      .getConnectedUsers(this.data.auctionId)
      .then((users: UserConnected[]) => {
        this.dataSource = new MatTableDataSource(users);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
      .finally(() => (this.isLoadingResults = false));
  }

  onApplyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  onClose() {
    this.dialogRef.close();
  }
}
